export const invalidSSNList = ['999-99-9999', '123-45-6789', '000-00-0000'];

export const includesInvalidSSN = (first = '', middle = '', last = '') => {
  const completeSSN = `${first}-${middle}-${last}`;

  return invalidSSNList.includes(completeSSN);
};
